import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss']
,  standalone: false
})
export class TextComponent implements OnInit {
    @Input() multiLine: boolean = false;
    @Input() labelText: string = "";
    @Input() isRequired: boolean = false;
    @Input() rowsMultiLine: number = 2;
    @Output() value: EventEmitter<string> = new EventEmitter();
    id = window.uniqueId();

    ngOnInit() {   
             //This blank function is mandatory.
    }
    textOnChange(event: string) {
        
        this.value.emit(event);
    }
}
